module.exports = __webpack_public_path__ + "static/LATERAL-45eb1e86031c4a70ad7359f7767fc9b1.webp";